import React, { useEffect, useState } from "react";
import "./StripePaywall.css"; // 🔥 importăm CSS-ul separat

const StripePaywall = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const clientId = localStorage.getItem("clientId");
    if (!clientId) return;

    fetch(
      `https://api-backend.full-trucking-service.com/api/clients/${clientId}/subscription`
    )
      .then((res) => res.json())
      .then((data) => setStatus(data.subscriptionStatus))
      .catch((err) => console.error("Error fetching subscription:", err));
  }, []);

  const handleSubscribe = async () => {
    const clientId = localStorage.getItem("clientId");

    const res = await fetch(
      `https://api-backend.full-trucking-service.com/api/subscribe`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ clientId }),
      }
    );

    const data = await res.json();
    if (data.url) window.location.href = data.url;
  };

  const handleLogout = async () => {
    try {
      await fetch(`https://api-backend.full-trucking-service.com/api/logout`, {
        method: "POST",
        credentials: "include",
      });

      localStorage.clear();
      window.location.href = "/login";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  if (status === "active") {
    return <p className="paywall-active">✅ Subscription Active – you can use the app!</p>;
  }

  return (
    <div className="paywall-container">
      <div className="paywall-card">
        <h2 className="paywall-title">
          Your subscription is <span>{status || "loading..."}</span>
        </h2>
        <p className="paywall-text">
          Please renew to continue using <strong>Full Trucking Service</strong>.
        </p>
        <button className="paywall-btn primary" onClick={handleSubscribe}>
          Go to Stripe Checkout
        </button>
        <button className="paywall-btn danger" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default StripePaywall;
